import { useQuery } from "@tanstack/react-query";
import { getMailingLists } from "../api/mailingListService";
import { MailingList } from "../api/types";

export const useMailingLists = () => {
  const query = useQuery<MailingList[]>({
    queryKey: ["mailing-lists"],
    queryFn: () => getMailingLists() as Promise<MailingList[]>,
    refetchOnWindowFocus: true,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  return query;
};
